<div class="loading-container">
  <div class="loading-content">
    <mat-spinner></mat-spinner>
  </div>
</div>

